import { ExternalPayrollConnection } from '@xemplo/gp-types';

export function getFieldsArray(connection: ExternalPayrollConnection) {
  const { name, externalBusinessUnitName, externalPayScheduleName } = connection;

  return [
    {
      id: 'connected-instance',
      label: 'Connected Instance',
      value: name || '-',
    },
    {
      id: 'business-unit',
      label: 'Business Unit',
      value: externalBusinessUnitName || '-',
    },
    {
      id: 'pay-schedule',
      label: 'Pay Schedule',
      value: externalPayScheduleName || '-',
    },
  ];
}
